import { cookiesUtils } from '@/utils/storage/cookies';
import { COOKIE_KEYS } from '@/constants/storage/cookies';
import { ANALYTICS, SOURCE } from '@/constants/analytics/analytics';
import { ROUTES } from '@/constants/app/routes';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { closeOnboarding, setFullPageLoader } from '@/store/reducers';
import { EAnalyticsProvider, useAnalytics, useNav } from '@/hooks';

type AnalyticsPayload = Record<string, unknown>;

export const useCompleteOnboardingAndRedirect = (): ((
  extraPayload?: AnalyticsPayload
) => void) => {
  const dispatch = useDispatch();
  const { fireAnalyticsEvent } = useAnalytics();
  const { nav } = useNav();

  return useCallback(
    (extraPayload: AnalyticsPayload = {}) => {
      cookiesUtils.removeCookie(COOKIE_KEYS.SHOW_NEW_SITE_ONBOARDING);

      // Clean up legacy onboarding cookies from the old site to prevent users
      // who reinstall during the A/B test from experiencing onboarding twice.
      cookiesUtils.removeCookie(COOKIE_KEYS.SHOW_ONBOARDING_MODAL);

      fireAnalyticsEvent(
        ANALYTICS.EVENTS.BRAZE.ONBOARDING_COMPLETE,
        { ...extraPayload },
        [EAnalyticsProvider.mixpanel, EAnalyticsProvider.braze]
      );

      dispatch(closeOnboarding());
      nav(`${ROUTES.HOME}?${SOURCE}=${ANALYTICS.SOURCE.ONBOARDING}`);
    },
    [dispatch, fireAnalyticsEvent, nav]
  );
};
